import Auth0Plugin, { getRedirectSuffix, type Auth0PluginOptions } from '@fusion/auth-v3'
import { type Router } from 'vue-router'

export const SlugsEnum = Object.freeze({
  AdminPanel: 'tsi:webapp:Administration:execute_sidebar_icon',
  LogInAs: 'tsi:webapp:Administration:execute_menu_choice:Log_In_As'
})

const permissionsOptions = {
  simple: [
    {
      slug: SlugsEnum.AdminPanel,
      propertyName: 'allowAdminPanelAccess'
    },

    {
      slug: SlugsEnum.LogInAs,
      propertyName: 'allowLogInAs'
    }
  ]
}

export const getAuthOptions = (router: Router): Auth0PluginOptions => {
  return {
    onRedirectCallback: () => {
      router.push(APP_ENV.VITE_APP_PUBLIC_PATH)
    },
    redirectSuffix: getRedirectSuffix(APP_ENV.VITE_APP_PUBLIC_PATH),
    domain: APP_ENV.VITE_APP_AUTH0_DOMAIN,
    clientID: APP_ENV.VITE_APP_AUTH0_CLIENT_ID,
    audience: APP_ENV.VITE_APP_AUTH0_AUDIENCE,
    cacheLocation: 'localstorage',
    useRefreshTokens: APP_ENV.VITE_APP_AUTH0_USE_REFRESH_TOKENS.toLowerCase() === 'true',
    permissionsOptions,
    loginMode: 'redirect',
    accountsHost: APP_ENV.VITE_APP_ACCOUNTS_HOST
  }
}

export default Auth0Plugin
